import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { AnimatedLink } from '../components/animated-link/AnimatedLink';

export const PricingBanner: FC = () => {
  return (
    <div className="banner-customers--grey">
      <div className="banner-customers__block">
        <div className="banner-customers__interview__small_header">
          <h2 className="banner-customers__title">
            <FormattedMessage id="pricing/PricingBanner.tsx/1" />
          </h2>
          <p className="banner-customers__subtitle">
            <FormattedMessage id="pricing/PricingBanner.tsx/2" />
          </p>
          <div className="vertical-align-elements">
            <AnimatedLink href="/tarifs?source=home_public">
              <FormattedMessage id="pricing/PricingBanner.tsx/3" />
            </AnimatedLink>
          </div>
        </div>
      </div>
    </div>
  );
};
